import { choreApproveTranslateEn } from "@pages/parents/pages/chores/pages/chore-approve/translate/en";
import { choreManageTranslateEn } from "@pages/parents/pages/chores/pages/chore-manage/translate/en";
import { choreDisabledTranslateEn } from "@pages/parents/pages/chores/pages/chores-disabled/translate/en";
import { choreViewTranslateEn } from "@pages/parents/pages/chores/pages/view-chore/translate/en";
import { chorePageTranslateEn } from "@pages/parents/pages/chores/translate/en";

export const choresTranslateEn = {
    CHORES:{
        ...chorePageTranslateEn,
        ...choreApproveTranslateEn,
        ...choreManageTranslateEn,
        ...choreViewTranslateEn,
        ...choreDisabledTranslateEn
    }
}